// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { HttpHeaders } from "@angular/common/http";

const GRAPH_BASE_URL = 'https://graph.microsoft.com/v1.0';
export const GRAPH_GROUPS_ENDPOINT = `${GRAPH_BASE_URL}/me/memberOf/microsoft.graph.group`;
export const GRAPH_HEADERS = new HttpHeaders({ ConsistencyLevel: 'eventual' });